module.exports = __webpack_public_path__ + "img/fg.9c12e83d.png";